import { useInterval } from "./utils/useInterval";

export const initializeEvents = (state, mainSource) => {
  let reloadTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(reloadTimeout);
    reloadTimeout = setTimeout(() => {
      window.location.reload();
    }, 1000);
  });

  useInterval(() => {
    if (state.isPaused) {
      return;
    }

    if (!mainSource.targetPosition) {
      return;
    }

    const xDiff = mainSource.targetPosition.x - mainSource.position.x;
    const yDiff = mainSource.targetPosition.y - mainSource.position.y;

    mainSource.position.x += xDiff / 10;
    mainSource.position.y += yDiff / 10;
  });
}; 